// extracted by mini-css-extract-plugin
module.exports = {"list":"CardList_list__1pVh4","empty":"CardList_empty__uP6A2","button":"CardList_button__QcDaJ"};